import type { ComponentWithAs, IconProps } from '@chakra-ui/react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IDefaultServiceRow {
  additionalInfo: string;
  description: string;
  icon: ComponentWithAs<'svg', IconProps>;
  id: string;
  name: string;
}

export const DefaultServiceRow: React.FC<IDefaultServiceRow> = ({
  additionalInfo,
  description,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  icon: Icon,
  id,
  name,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Flex
      _last={{ borderBottom: '1px', borderColor: 'black' }}
      alignItems="center"
      borderColor="black"
      borderTop="1px"
      flexDirection={{ base: 'column', md: 'row' }}
      gap={{ base: 4, md: 8 }}
      justifyContent="space-between"
      key={id}
      pl={8}
      py={{ base: 4, md: 12 }}
    >
      <Flex alignItems="center" flexBasis={{ base: 'max-content', md: '800px' }} gap={8} w="full">
        <Icon h={20} w={20} />
        <Box>
          <Text fontSize={{ base: 'h3.base', md: 'h3.md' }} fontWeight="bold">
            {t(name)}
          </Text>
          <Text color="brand.red.light">{t(additionalInfo)}</Text>
        </Box>
      </Flex>
      <Text flexGrow={1} maxWidth={{ base: '100%', md: '50%' }} minW="50%">
        {t(description)}
      </Text>
    </Flex>
  );
};
